export const CAMPAIGN_TYPES = [
  { label: 'CPA', value: 'cpa' },
  { label: 'Flat fee', value: 'flat fee' },
  { label: 'Fixed fee', value: 'fixed fee' },
  { label: 'Hybrid', value: 'hybrid' },
]
